import { render, staticRenderFns } from "./StaticSites.vue?vue&type=template&id=070d8daf&scoped=true"
import script from "./StaticSites.vue?vue&type=script&lang=js"
export * from "./StaticSites.vue?vue&type=script&lang=js"
import style0 from "./StaticSites.vue?vue&type=style&index=0&id=070d8daf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070d8daf",
  null
  
)

export default component.exports